<template>
  <div class="hide-content">
    <div class="img-placeholder">
      <img src="@/assets/images/my-quiz-answer/empty-answers.svg">
    </div>
    <p v-if="lookbackTab === 'MyQuizAnswers'">
      {{ msg ? msg : $t('review_all_questions') }}
    </p>
    <p v-if="lookbackTab === 'LookbackSharingView'">
      {{ msg ? msg : $t('review_all_slides_and_questions') }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    lookbackTab: {
      type: String,
      default: 'MyQuizAnswers',
      validator(value) {
        return ['MyQuizAnswers', 'LookbackSharingView'].indexOf(value) !== -1
      },
    },
    msg: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.hide-content {
  text-align: center;
  color: var(--base-90, #313131);

  .img-placeholder {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  p {
    margin-top: 0;
    font-size: 16px;
  }
}
</style>
